/**
 * Twelve account-shaped concepts, drawn in AccountIcon.vue rather than imported from a
 * second icon library - see AccountIcon.vue's own comment for why.
 */
export const ACCOUNT_ICON_NAMES = [
  'BANK',
  'CASH',
  'CARD',
  'WALLET',
  'CHART',
  'SAVINGS',
  'INVESTMENT',
  'CRYPTO',
  'HOME',
  'SHOPPING',
  'GIFT',
  'GLOBAL',
] as const

export type AccountIconName = (typeof ACCOUNT_ICON_NAMES)[number]
